import React, { useEffect, useState, useRef } from "react";
import { IconButton, Tooltip } from "@mui/material";
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import VisibilityIcon from "@mui/icons-material/Visibility";
import InteriorView from '@mui/icons-material/CameraIndoor';
import cameraControlStyle from "./cameraControlStyle";
import HumanView from '@mui/icons-material/EmojiPeople';

const CameraControl = ({viewerRef}) => {
    const classes = cameraControlStyle();
    const [isExpanded, setIsExpanded] = useState(false);
    const viewMenuRef = useRef(null);
    const cameraButtonRef = useRef(null);

    const handleToggle = () => {
        setIsExpanded(prev => {
            return !prev;
        });
    };

    //Three predefined views
    const handleViewChange = (viewType) => {
        if (!viewerRef.current) return;
        const camera = viewerRef.current.scene.camera;
        switch (viewType) {
            case "interior":
                console.log("Switching to Interior View");
                camera.eye = [160.6161, 7.5384, -179.5932];
                camera.look = [155.4447, 7.3844, -171.4328];
                camera.up = [-0.0085, 0.9999, 0.0135];
                break;

            case "distant":
                console.log("Switching to Default View");
                camera.eye = [218.2763, 117.6771, 248.5256];
                camera.look = [75.9425, 44.9766, 25.6039];
                camera.up = [-0.1426, 0.9642, -0.2233];
                break;

            case "human":
                console.log("Switching to Human View");
                camera.eye = [38.9018, 1.6, -174.4709];
                camera.look = [27.2028, 5.017, -158.9353];
                camera.up = [0.1264, 0.9776, -0.1679];
                break;

            default:
                console.warn("Unknown view type:", viewType);
        }

        setIsExpanded(false);
    };

    //Collapse menu when clicking outside
    useEffect(()=>{
        function handleClickOutside(event){
            if(viewMenuRef.current && 
                !viewMenuRef.current.contains(event.target)&&
                cameraButtonRef.current &&
                !cameraButtonRef.current.contains(event.target)
            ){
                setIsExpanded(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return()=> document.removeEventListener("mousedown", handleClickOutside);
    }, []);



    return (
        <div className={classes.container}>
            {/* Camera View Button */}
            <div className={classes.cameraButtonContainer} ref= {cameraButtonRef}>
                <Tooltip title="Switch Camera View" arrow>
                    <IconButton className={classes.cameraButton} onClick={handleToggle}>
                        <CameraswitchIcon className={classes.cameraIcon} />
                    </IconButton>
                </Tooltip>
            </div>

            {/* Predefined View Buttons (Shown when expanded) */}
            {isExpanded && (
                <div className={classes.viewButtonsContainer} ref={viewMenuRef}>
                    <Tooltip title="Interior View" arrow placement="right">
                        <IconButton
                            className={classes.viewButton}
                            onClick={() => handleViewChange("interior")}
                        >
                            <InteriorView className={classes.viewIcon} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Panaromic View" arrow placement="right">
                        <IconButton
                            className={classes.viewButton}
                            onClick={() => handleViewChange("distant")}
                        >
                            <VisibilityIcon className={classes.viewIcon} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Human View" arrow placement="right">
                        <IconButton
                            className={classes.viewButton}
                            onClick={() => handleViewChange("human")}
                        >
                            <HumanView className={classes.viewIcon} />
                        </IconButton>
                    </Tooltip>
                </div>
            )}


        </div>
    );
};

export default CameraControl;
